/* jshint node:true */
'use strict';

var React = require('react');
var Router = require('react-router');
var Link = require('react-router').Link;
var FluxibleMixin = require('fluxible/addons/FluxibleMixin');
var RouteHandler = require('react-router').RouteHandler;
var Navbar = require('../common/Navbar.jsx');

var Application = React.createClass({

    mixins: [Router.State, FluxibleMixin],

    getInitialState: function () {
        return {};
    },

    onChange: function () {

    },

    render: function () {
        
        // Query params to test app w/o ESPN shell
        var nav = <Navbar />;
        var query = this.getQuery();
        var shell = query.shell || 'true';
        if(shell === 'true' && !window.__noShell){
            nav = null;
        }
        
        return (
            <div>
                {nav}
                <RouteHandler shell={nav ? false : true} context={this.props.context} />
                <div dangerouslySetInnerHTML={{__html: "<style>*{-webkit-tap-highlight-color: rgba(0,0,0,0)}*:focus{outline:none}</style>"}}>
                </div>
            </div>
        );
    }
});

module.exports = Application;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/handlers/Application.jsx
 **/